import React from "react";
import Alert from "@material-ui/lab/Alert";
import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";

const WorkflowElementState = (props: { item?: ICardElementWithChildren }) => {
  const { item } = props;

  if (!item) return null;

  switch (item?.workflowInstance?.currentState as string) {
    case "approval":
      return null;
    case "approvalrejected":
      return (
        <Alert severity="warning">
          {t(
            "workflowinput.Alert.Approval was Rejected"
          )}
          <div>Message: {item?.workflowInstance?.latestLog.message}</div>
        </Alert>
      );
    case "finalapproval":
      return null;
    case "dataentry":
      return null;
    case "draft":
    return (
      <Alert severity="info">
        {t("workflowinput.Alert.Draft")}
      </Alert>
    );
    case "finalapprovalrejected":
      return (
        <Alert severity="warning">
          {t("workflowinput.Alert.Final Approval was Rejected")}
          <div>Message: {item?.workflowInstance?.latestLog.message}</div>
        </Alert>
      );
  }
  return <div>-</div>;
};

export default WorkflowElementState;
